import { initFinder } from 'uhs-finder.dom';

function boot(scope) {
  const root = scope.querySelector('[data-uhs-finder]');
  if (!root) return;

  try {
    initFinder(root);
  } catch (err) {
    console.error('UHS finder init failed:', err);
  }
}


boot(document);





document.addEventListener('shopify:section:load', event => {
  if (event.target && typeof event.target.querySelector === 'function') boot(event.target);
});
